import { STORAGE_LOCALE } from 'constants/app-constants';

const useLocale = () => window.localStorage.getItem(STORAGE_LOCALE) || 'en';

export default useLocale;
